import { PseudoSection } from 'components/main/section-router/pseudo-section';
import { t } from 'i18next';

export const GameInProgress = () => (
  <PseudoSection
    header={t('main.game-in-progress')}
    content={
      <>
        <p>There is a game in progress for your team.</p>
        <p>
          As a result, certain features of the application will be unavailable
          or restricted until after the game.
        </p>
      </>
    }
  />
);
